export default __webpack_public_path__ + "static/media/06_ChuHungOilSeals.ce9a5b0e.png";